const faroConfig = {
  url: import.meta.env.VITE_FARO_URL || "",
  app: {
    name: import.meta.env.VITE_FARO_APP_NAME || "pass",
    version: import.meta.env.VITE_FARO_APP_VERSION || null
  }
}

export default faroConfig
